import { TableCell } from "@mui/material";
import { useState } from "react";
import { Button, Loading, Modal } from "src/Components";
import { IFreezedCoveredCallTableReport } from "src/Interfaces/collateral";
import {
  getAdaptationLogTable,
  sendManualCMD,
  sendOptimizedFreeze,
} from "src/Requests/collateral";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { AdaptationLogTable } from "./AdaptationLogAdditional";
import { toast } from "react-toastify";

const FreezeCoveredCallTableAdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
      <TableCell />
    </>
  );
};

const FreezeCoveredCallTableAdditionalCol: React.FC<{
  row: IFreezedCoveredCallTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [optimizedLoading, setOptimzedLoading] = useState(false);

  const sendManualCMDHandler = () => {
    setLoading(true);
    sendManualCMD({
      baseinstrumentid: row.baseinstrumentid,
      userid: row.userid,
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const sendOptimizedFreezeHandler = () => {
    setOptimzedLoading(true);
    sendOptimizedFreeze({
      baseinstrumentid: row.baseinstrumentid,
      userid: row.userid,
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setOptimzedLoading(false));
  };

  return (
    <>
      <TableCell>
        <Button
          text={loading ? <Loading /> : "تطبیق دستی"}
          variant="outlined"
          onClick={sendManualCMDHandler}
          loading={loading}
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        <Button
          text={optimizedLoading ? <Loading /> : "بهینه سازی"}
          variant="outlined"
          onClick={sendOptimizedFreezeHandler}
          loading={optimizedLoading}
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isLogModalOpen ? (
          <Modal
            title="بهینه سازی"
            UI={
              <TableTemplate
                TableUI={({ reports, onAction }) => (
                  <CommonTableUI
                    reports={reports}
                    onAction={onAction}
                    AdditionalBody={AdaptationLogTable}
                  />
                )}
                getDataTable={getAdaptationLogTable}
                searchParameters={{
                  baseinstrumentid: row.baseinstrumentid,
                  userid: row.userid,
                }}
              />
            }
            onClose={() => setIsLogModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsLogModalOpen(true)}
          text="لاگ تطبیق"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const FreezeCoveredCallTableAdditional: IAdditional<IFreezedCoveredCallTableReport> =
  {
    getHeader: FreezeCoveredCallTableAdditionalHeader,
    getRow: FreezeCoveredCallTableAdditionalCol,
  };
